module.exports = __webpack_public_path__ + "static/media/Alias AutoStudio.3a26e9fd.png";